import { render, staticRenderFns } from "./Indicators.vue?vue&type=template&id=3efaefc6&"
import script from "./Indicators.vue?vue&type=script&lang=js&"
export * from "./Indicators.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports